import cx from 'classnames';
import { CanonicalAvatar } from '@atlassian/trello-canonical-components';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Avatars } from '@trello/members';
import React from 'react';
import styles from './member-avatar.less';
const format = forTemplate('member');

// Order matters here, if you add a new one,
// ensure it remains in ascending order
const AVATAR_SIZES = [30, 50, 170];

export interface MemberAvatarProps {
  className?: string;
  idMember?: string;
  name?: string;
  username?: string;
  avatars?: Avatars;
  initials?: string;
  size?: number; // pixels
  onClick?: React.EventHandler<React.SyntheticEvent>;
  gold?: boolean;
  hoverable?: boolean;
  admin?: 'board' | 'organization';
}

export const MemberAvatar = ({
  className = '',
  idMember,
  name,
  username,
  avatars,
  initials,
  size = 30,
  onClick,
  gold = false,
  hoverable,
  admin,
}: MemberAvatarProps) => {
  if (!idMember) {
    return <span />;
  }
  const interactive = hoverable || !!onClick;
  const resolution = AVATAR_SIZES.find((s) => s >= size);
  const resolution2x = AVATAR_SIZES.find((s) => s >= size * 2) || resolution;

  if (resolution === undefined || resolution2x === undefined) {
    throw new Error('Invalid member avatar size');
  }

  return (
    <div
      className={cx(className, styles.memberAvatar)}
      title={`${name} (${username})`}
      onClick={onClick}
      role={onClick && 'button'}
    >
      <CanonicalAvatar
        key={idMember}
        className={cx(
          interactive && styles.hoverable,
          avatars ? styles.withImage : null,
        )}
        img={avatars && avatars[resolution]}
        img2x={avatars && avatars[resolution2x]}
        initials={initials}
        size={size}
      />
      {gold && (
        <span
          className={styles.gold}
          title={format('this-member-has-trello-gold')}
        />
      )}
      {admin && (
        <span
          className={styles.admin}
          title={format(`this-member-is-an-admin-of-this-${admin}`)}
        />
      )}
    </div>
  );
};
